<template>
  <OrganismModal
    v-model:is-shown="isModalOpen"
    data-cy="how-encore-works-modal"
    :title="t('subscription.physicalBattery.howEncoreWorksModal.title')"
    has-separator
    size="lg"
    @cancel="handleClose"
  >
    <AtomText
      :text="t('subscription.physicalBattery.howEncoreWorksModal.intro')"
      font-style="font-semibold"
      font-size="text-base"
      class="mb-6"
    />

    <div class="flex flex-col gap-1">
      <AtomText
        v-for="(step, index) in tm('subscription.physicalBattery.howEncoreWorksModal.steps')"
        :key="index"
        :text="step"
        font-style="font-medium"
        font-size="text-base"
        data-cy="how-encore-works-modal-step"
      />
    </div>

    <MoleculeStandaloneLink
      :label="t('subscription.physicalBattery.encore.learnMore')"
      type="url"
      :to="t('common.link.encoreOffer')"
      target="blank"
      icon-name="ExternalLinkIcon"
      color-variant="brand"
      font-size="sm"
      font-weight="medium"
      class="mt-8"
      data-cy="how-encore-works-modal-learn-more-link"
    />

    <template #footer="{ cancel }">
      <div class="flex justify-end">
        <MoleculeButton
          data-cy="how-encore-works-modal-close-button"
          variant="tertiary"
          :label="t('common.close')"
          @click="cancel"
        />
      </div>
    </template>
  </OrganismModal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits(['update:isOpen']);

const { t, tm } = useI18n();

const isModalOpen = computed({
  get: () => props.isOpen,
  set: (newState: boolean) => {
    emit('update:isOpen', newState);
  },
});

const handleClose = () => (isModalOpen.value = false);
</script>
